// TODO Delete/Migrate stuff away from this file. Just keep it for legacy reasons for now.
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import './megaMenu';
import './Fund/CurrencyUpdater';
import './Fund/FundPage';
import './Fund/SimpleFundList';
import './Pages/main';
import './Pages/theme-article-page';
import './Pages/theme-page';
import './ToolTip/toolTipSearch';
// Moved an update scripts
import './skagenweb';
import './replaceText';
import './responsive-tables';
import './placeholder';
import './Common/SetupDatePicker';

import { trackPageView } from './components/GoogleTagManager';
import 'jquery/dist/jquery';
import 'jquery-validation/dist/jquery.validate';
import 'jquery-ajax-unobtrusive';
import 'jquery-validation-unobtrusive';
import 'bootstrap-sass';

trackPageView();
